/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { DxoChartCommonAnnotationConfig } from './base/chart-common-annotation-config';


@Component({
    selector: 'dxo-common-annotation-settings',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'argument',
        'arrowLength',
        'arrowWidth',
        'axis',
        'border',
        'color',
        'customizeTooltip',
        'description',
        'font',
        'height',
        'image',
        'opacity',
        'paddingLeftRight',
        'paddingTopBottom',
        'series',
        'shadow',
        'text',
        'textOverflow',
        'tooltipEnabled',
        'type',
        'value',
        'width',
        'wordWrap',
        'x',
        'y'
    ]
})
export class DxoCommonAnnotationSettingsComponent extends DxoChartCommonAnnotationConfig {

    protected get _optionPath() {
        return 'commonAnnotationSettings';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoCommonAnnotationSettingsComponent
  ],
  exports: [
    DxoCommonAnnotationSettingsComponent
  ],
})
export class DxoCommonAnnotationSettingsModule { }
